import React from 'react';
import { SectionWrapper } from './SectionWrapper';
const items = [{
  name: 'Protocolo Calma 3 Minutos — PDF completo',
  price: '$47'
}, {
  name: 'Guía de bolsillo imprimible',
  price: '$17'
}, {
  name: 'Checklists de aplicación por capítulo',
  price: '$12'
}, {
  name: 'Scripts y frases exactas listos para usar',
  price: '$17'
}, {
  name: 'Worksheets de escenarios de alto riesgo',
  price: '$12'
}, {
  name: 'FAQ de intervención de emergencia',
  price: '$9'
}];
export function ValueStack() {
  return <SectionWrapper className="bg-white py-20" data-id="element-339">
      <div className="bg-cream p-8 md:p-12 rounded-xl shadow-soft max-w-2xl mx-auto border border-hairline" data-id="element-340">
        <h2 className="font-sans text-3xl font-bold text-ink mb-8 text-center" data-id="element-341">
          Todo lo que recibes hoy
        </h2>

        <div className="space-y-4 mb-8" data-id="element-342">
          {items.map((item, index) => <div key={index} className="flex items-center py-2" data-id="element-343">
              <div className="flex items-start gap-3" data-id="element-344">
                <span className="text-green-500 shrink-0" data-id="element-345">✅</span>
                <span className="font-sans text-ink-mid font-medium" data-id="element-346">
                  {item.name}
                </span>
              </div>
            </div>)}
        </div>

        <hr className="border-hairline mb-6" data-id="element-347" />

        <div className="flex justify-between items-center mb-6 px-2" data-id="element-348">
          <span className="font-sans text-ink-mid font-bold" data-id="element-349">
            Valor total real:
          </span>
          <span className="font-sans text-ink-light line-through font-bold text-lg" data-id="element-350">
            $15,99
          </span>
        </div>

        <hr className="border-hairline mb-6" data-id="element-351" />

        <div className="bg-coral-light p-6 rounded-xl text-center" data-id="element-352">
          <p className="font-sans text-3xl md:text-4xl font-bold text-coral-dark" data-id="element-353">
            🔥 Tu inversión hoy: $9.99
          </p>
        </div>
      </div>
    </SectionWrapper>;
}